import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useActualIncidentId } from '../hooks/commonHooks';
import { useIcs201Op0 } from 'hooks/incident/useIcs201Op0';
import { useUscgMapContext } from 'components/MapPage/CorporateViewTabs/LayersTab/UscgMapContext';
import { useIcsFormPdfPreview } from '../context/IcsFormPdfPreviewContext';
import { useIcsFormFamily } from '../hooks/useIcsFormFamily';
import useDownloadFile from 'components/FileManagement/hooks/useDownloadFile';
import { useSignedUrl } from 'components/FileManagement/hooks/useNotebookQueries';
import { toast } from 'react-toastify';

export const GenerateIcs201Button = () => {
  const { previewFromSignedUrl, exportAsForm } = useIcsFormPdfPreview();
  const formFamily = useIcsFormFamily();
  const { captureMapSketchFile } = useUscgMapContext();
  const downloadFile = useDownloadFile();
  const incidentId = useActualIncidentId();
  const { existing201File, displayDocuments } = useIcs201Op0(incidentId);
  const { mutateAsync: getSignedUrl, isPending: isLoadingUrl } = useSignedUrl();

  const handlePreview = async () => {
    if (!existing201File) return;

    try {
      const signedUrl = await getSignedUrl(existing201File.fileUrl);

      previewFromSignedUrl({
        fileUrl: signedUrl,
        fileName: existing201File.file_name,
        onDownload: () => {
          void downloadFile(existing201File);
        },
      });
    } catch (_error) {
      toast.error('Failed to load preview');
    }
  };

  const handleGenerateAndPreview = async () => {
    const mapSketch = await captureMapSketchFile();
    exportAsForm({
      formname: 'ICS_201-CG',
      data: {},
      mapSketch: mapSketch ?? null,
      periodNumber: 0,
      format: formFamily === 'fema' ? 'docx' : 'pdf',
    });
  };

  const fileExists = Boolean(displayDocuments);

  if (fileExists) {
    return (
      <div className="d-flex align-items-center gap-2">
        <StylishNewButton
          onClick={(e) => {
            e.stopPropagation();
            handleGenerateAndPreview();
          }}
          className="button button--secondary"
        >
          <SharedIcon iconName="refresh" classes="me-2" size="sm" />
          Update ICS-201
        </StylishNewButton>
        <StylishNewButton
          onClick={(e) => {
            e.stopPropagation();
            handlePreview();
          }}
          disabled={isLoadingUrl}
          className="button button--primary"
        >
          <SharedIcon iconName="visibility" classes="me-2" size="sm" />
          Preview ICS-201
        </StylishNewButton>
      </div>
    );
  }

  return (
    <StylishNewButton
      className="button button--secondary"
      onClick={(e) => {
        e.stopPropagation();
        handleGenerateAndPreview();
      }}
    >
      <SharedIcon iconName="download" classes="me-2" size="sm" />
      <span>Generate & Preview New ICS-201</span>
    </StylishNewButton>
  );
};
